// import React, { useState, useEffect } from 'react'
// import {
//   Drawer,
//   Button,
//   Popconfirm,
//   Tag,
//   Typography,
//   Empty,
//   Dropdown,
//   Menu,
// } from 'antd'
// import {
//   PlusOutlined,
//   DeleteOutlined,
//   ScissorOutlined,
//   MergeOutlined,
//   ShopOutlined,
//   TeamOutlined,
//   AppstoreOutlined,
//   MoreOutlined,
//   CheckCircleOutlined,
//   ClockCircleOutlined,
//   CoffeeOutlined,
// } from '@ant-design/icons'

// import SplitBillModal from './SplitBillModal'
// import MergeBillsModal from './MergeBillsModal'
// import BillEditorNoContext from './BillEditorNoContext'
// import SplitBillModalNoContext from './SplitBillModalNoContext'
// import './BillPanelNoContext.css'
// import MergeBillsModalNoContext from './MergeBillsModalNoContext'

// const { Text } = Typography

// const BillPanelNoContext = ({
//   table,
//   bills = [],
//   initialBillId,
//   onClose,

//   menuItems = [],
//   categories = [],

//   onAddBill,
//   onDeleteBill,
//   onMergeBills,
//   onSplitBill,
//   onUpdateBillItems,
//   onUpdateBillMeta,
//   onCloseBill,

//   getBillTotal,
//   refreshBillsForTable,
// }) => {
//   const [activeKey, setActiveKey] = useState(() =>
//     initialBillId
//       ? String(initialBillId)
//       : bills[0]?.id
//       ? String(bills[0].id)
//       : null
//   )

//   const [splitState, setSplitState] = useState({ billId: null, items: [] })
//   const [mergeBillsOpen, setMergeBillsOpen] = useState(false)
//   const [addingBill, setAddingBill] = useState(false)

//   useEffect(() => {
//     if (bills.length === 0) {
//       setActiveKey(null)
//       return
//     }

//     const exists = bills.find((b) => String(b.id) === activeKey)
//     if (!exists) {
//       setActiveKey(bills[0]?.id ? String(bills[0].id) : null)
//     }
//   }, [bills, activeKey])

//   useEffect(() => {
//     if (
//       initialBillId &&
//       bills.find((b) => String(b.id) === String(initialBillId))
//     ) {
//       setActiveKey(String(initialBillId))
//     }
//   }, [initialBillId, bills])

//   useEffect(() => {
//     if (
//       splitState.billId &&
//       !bills.find((b) => String(b.id) === String(splitState.billId))
//     ) {
//       setSplitState({ billId: null, items: [] })
//     }
//   }, [bills, splitState.billId])

// //   const handleAddBill = async () => {
// //     setAddingBill(true)
// //     try {
// //       const newBill = await onAddBill(table.id)
// //       if (newBill?.id) setActiveKey(String(newBill.id))
// //     } finally {
// //       setAddingBill(false)
// //     }
// //   }
// const handleAddBill = async () => {
//   setAddingBill(true)
//   try {
//     const newBill = await onAddBill(table.id)

//     // ✅ call getBillsByTableId (refresh)
//     let updatedBills = []

//     if (typeof refreshBillsForTable === 'function') {
//       updatedBills = await refreshBillsForTable(table.id)
//     }

//     // ✅ select correct bill
//     if (newBill?.id) {
//       setActiveKey(String(newBill.id))
//     } else if (updatedBills?.length) {
//       const lastBill = updatedBills[updatedBills.length - 1]
//       setActiveKey(String(lastBill.id))
//     }
//   } catch (err) {
//     console.error('Add bill failed:', err)
//   } finally {
//     setAddingBill(false)
//   }
// }
//   const handleDelete = async (billIdKey) => {
//     const billId = parseInt(billIdKey, 10) || billIdKey
//     await onDeleteBill(table.id, billId)
//   }

//   const activeBill = bills.find((b) => String(b.id) === String(activeKey))

//   const splitTargetBill = splitState.billId
//     ? bills.find((b) => String(b.id) === String(splitState.billId))
//     : null

//   const zoneColorMap = {
//     Outdoor: { bg: '#f6ffed', border: '#b7eb8f', text: '#52c41a' },
//     Bar: { bg: '#f9f0ff', border: '#d3adf7', text: '#722ed1' },
//     Private: { bg: '#fff7e6', border: '#ffd591', text: '#fa8c16' },
//     Indoor: { bg: '#e6f7ff', border: '#91d5ff', text: '#1890ff' },
//   }

//   const zoneStyle = zoneColorMap[table?.zone] || {
//     bg: '#f5f5f5',
//     border: '#d9d9d9',
//     text: '#8c8c8c',
//   }

//   const totalBills = bills.length
//   const totalItems = bills.reduce(
//     (sum, bill) => sum + (bill.items?.length || 0),
//     0
//   )

//   const getBillStatus = (bill) => {
//     const itemCount = bill.items?.length || 0
//     if (itemCount === 0) {
//       return {
//         label: 'Empty',
//         icon: <ClockCircleOutlined />,
//         color: '#8c8c8c',
//       }
//     }
//     if (bill.paid) {
//       return {
//         label: 'Paid',
//         icon: <CheckCircleOutlined />,
//         color: '#52c41a',
//       }
//     }
//     return {
//       label: 'Active',
//       icon: <CoffeeOutlined />,
//       color: '#1890ff',
//     }
//   }

//   const actionMenu = (
//     <Menu>
//       {bills.length >= 2 && (
//         <Menu.Item
//           key="merge"
//           icon={<MergeOutlined />}
//           onClick={() => setMergeBillsOpen(true)}
//         >
//           Merge Bills
//         </Menu.Item>
//       )}
//       <Menu.Item key="add" icon={<PlusOutlined />} onClick={handleAddBill}>
//         Add New Bill
//       </Menu.Item>
//     </Menu>
//   )

//   return (
//     <Drawer
//       className="bill-panel-drawer"
//       placement="right"
//       width={820}
//       open={true}
//       onClose={onClose}
//       closable={true}
//       closeIcon={<span className="close-icon">×</span>}
//       title={null}
//     >
//       <div className="bill-panel-container">
//         <div className="bill-panel-header">
//           <div className="bill-panel-header-main">
//             <div className="table-info-card">
//               <div
//                 className="table-icon"
//                 style={{
//                   background: zoneStyle.bg,
//                   borderColor: zoneStyle.border,
//                 }}
//               >
//                 <ShopOutlined style={{ color: zoneStyle.text }} />
//               </div>

//               <div className="table-info">
//                 <div className="table-name-row">
//                   <h2 className="table-name">{table?.name}</h2>
//                   <Tag
//                     className="zone-tag"
//                     style={{
//                       background: zoneStyle.bg,
//                       color: zoneStyle.text,
//                       borderColor: zoneStyle.border,
//                     }}
//                   >
//                     {table?.zone || 'Indoor'}
//                   </Tag>
//                 </div>

//                 <div className="table-stats">
//                   <div className="stat-item">
//                     <TeamOutlined className="stat-icon" />
//                     <span className="stat-value">Capacity {table?.capacity}</span>
//                   </div>

//                   <div className="stat-divider" />

//                   <div className="stat-item">
//                     <AppstoreOutlined className="stat-icon" />
//                     <span className="stat-value">
//                       {totalBills} {totalBills === 1 ? 'bill' : 'bills'}
//                     </span>
//                   </div>

//                   <div className="stat-divider" />

//                   <div className="stat-item">
//                     <CoffeeOutlined className="stat-icon" />
//                     <span className="stat-value">
//                       {totalItems} {totalItems === 1 ? 'item' : 'items'}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="header-actions">
//               <Dropdown overlay={actionMenu} trigger={['click']} placement="bottomRight">
//                 <Button className="action-btn-mobile" icon={<MoreOutlined />} />
//               </Dropdown>

//               <div className="action-buttons">
//                 {bills.length >= 2 && (
//                   <Button
//                     icon={<MergeOutlined />}
//                     onClick={() => setMergeBillsOpen(true)}
//                     className="action-btn secondary"
//                   >
//                     Merge
//                   </Button>
//                 )}

//                 <Button
//                   type="primary"
//                   icon={<PlusOutlined />}
//                   onClick={handleAddBill}
//                   loading={addingBill}
//                   className="action-btn primary"
//                 >
//                   New Bill
//                 </Button>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="bill-panel-body">
//           {bills.length === 0 ? (
//             <div className="empty-state">
//               <div className="empty-icon">📋</div>
//               <Empty
//                 description={
//                   <div className="empty-description">
//                     <div className="empty-title">No active bills</div>
//                     <div className="empty-subtitle">
//                       Start a new bill for this table to begin ordering
//                     </div>
//                   </div>
//                 }
//               >
//                 <Button
//                   type="primary"
//                   icon={<PlusOutlined />}
//                   onClick={handleAddBill}
//                   size="large"
//                   className="create-bill-btn"
//                 >
//                   Create First Bill
//                 </Button>
//               </Empty>
//             </div>
//           ) : (
//             <div className="bills-container">
//               <div className="custom-tabs">
//                 <div className="tabs-topbar">
//                   <div className="tabs-topbar-left">
//                     <h3 className="tabs-title">Bills</h3>
//                     <Text type="secondary" className="tabs-subtitle">
//                       Switch bills, split current bill or delete it
//                     </Text>
//                   </div>

//                   {activeKey && activeBill && (
//                     <div className="bill-actions">
//                       <Button
//                         icon={<ScissorOutlined />}
//                         onClick={() =>
//                           setSplitState({
//                             billId: activeBill.id,
//                             items: activeBill.items || [],
//                           })
//                         }
//                         className="action-icon-btn"
//                       >
//                         Split
//                       </Button>

//                       <Popconfirm
//                         title="Delete this bill?"
//                         description="This action cannot be undone."
//                         onConfirm={() => handleDelete(activeKey)}
//                         okText="Delete"
//                         cancelText="Cancel"
//                         okButtonProps={{ danger: true }}
//                       >
//                         <Button
//                           danger
//                           icon={<DeleteOutlined />}
//                           className="action-icon-btn"
//                         >
//                           Delete
//                         </Button>
//                       </Popconfirm>
//                     </div>
//                   )}
//                 </div>

//                 <div className="tabs-header">
//                   {bills.map((bill, idx) => {
//                     const { total } = getBillTotal(bill)
//                     const itemCount = bill.items?.length || 0
//                     const status = getBillStatus(bill)
//                     const isActive = String(bill.id) === activeKey

//                     return (
//                       <button
//                         key={bill.id}
//                         className={`tab-button ${isActive ? 'active' : ''}`}
//                         onClick={() => setActiveKey(String(bill.id))}
//                       >
//                         <div className="tab-content">
//                           <div className="tab-header">
//                             <span className="tab-name">
//                               {bill.mergedFrom
//                                 ? `Merged (${bill.mergedFrom})`
//                                 : `Bill ${idx + 1}`}
//                             </span>

//                             <div
//                               className="tab-status"
//                               style={{ color: status.color }}
//                             >
//                               {status.icon}
//                               <span className="tab-status-text">
//                                 {status.label}
//                               </span>
//                             </div>
//                           </div>

//                           <div className="tab-footer">
//                             <span className="tab-items">
//                               {itemCount} {itemCount === 1 ? 'item' : 'items'}
//                             </span>
//                             <span className="tab-total">₹{total.toFixed(0)}</span>
//                           </div>
//                         </div>
//                       </button>
//                     )
//                   })}
//                 </div>

//                 <div className="tabs-content">
//                   {activeBill && (
//                     <BillEditorNoContext
//                       key={activeBill.id}
//                       bill={activeBill}
//                       tableId={table.id}
//                       onSplit={() =>
//                         setSplitState({
//                           billId: activeBill.id,
//                           items: activeBill.items || [],
//                         })
//                       }
//                       updateBillItems={onUpdateBillItems}
//                       updateBillMeta={onUpdateBillMeta}
//                       closeBill={onCloseBill}
//                       getBillTotal={getBillTotal}
//                       menuItems={menuItems}
//                       categories={categories}
//                     />
//                   )}
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
// {splitTargetBill && (
//   <SplitBillModalNoContext
//     bill={splitTargetBill}
//     tableId={table.id}
//     onClose={() => setSplitState({ billId: null, items: [] })}
//     onSplitBill={async ({ item_ids }) => {
//       await onSplitBill(table.id, splitTargetBill.id, item_ids)
//       setSplitState({ billId: null, items: [] })
//     }}
//   />
// )}

// {mergeBillsOpen && (
//   <MergeBillsModalNoContext
//     tableId={table.id}
//     bills={bills}
//     activeKey={activeKey}
//     onClose={() => setMergeBillsOpen(false)}
//     onMergeBills={async (sourceBillId, targetBillId) => {
//       await onMergeBills(table.id, sourceBillId, targetBillId)

//       if (typeof refreshBillsForTable === 'function') {
//         await refreshBillsForTable(table.id)
//       }

//       setActiveKey(String(targetBillId))
//       setMergeBillsOpen(false)
//     }}
//   />
// )}
//     </Drawer>
//   )
// }

// export default BillPanelNoContext

import React, { useState, useEffect } from "react";
import {
  Drawer,
  Button,
  Popconfirm,
  Tag,
  Typography,
  Empty,
  Dropdown,
  Menu,
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  ScissorOutlined,
  MergeOutlined,
  ShopOutlined,
  TeamOutlined,
  AppstoreOutlined,
  MoreOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  CoffeeOutlined,
} from "@ant-design/icons";

import BillEditorNoContext from "./BillEditorNoContext";
import SplitBillModalNoContext from "./SplitBillModalNoContext";
import MergeBillsModalNoContext from "./MergeBillsModalNoContext";
import "./BillPanelNoContext.css";

const { Text } = Typography;

const getDrinkLineTotal = (drinkDetails) => {
  if (!drinkDetails) return 0;
  const details =
    typeof drinkDetails === "string"
      ? JSON.parse(drinkDetails || "{}")
      : drinkDetails;

  const pegs = details?.pegs || [];
  const pegQtys = details?.peg_qtys || {};
  const bottleQty = Number(details?.bottle_qty || 0);
  const bottlePrice = Number(details?.price_bottle || 0);

  const bottleTotal = bottleQty * bottlePrice;
  const pegTotal = pegs.reduce((sum, peg) => {
    const qty = Number(pegQtys[String(peg.id)] || 0);
    return sum + qty * Number(peg.price || 0);
  }, 0);

  return bottleTotal + pegTotal;
};

const getLiveBillTotal = (bill) => {
  const items = Array.isArray(bill?.items) ? bill.items : [];
  return items.reduce((sum, item) => {
    if (Number(item?.is_drink || 0) === 1 && item?.drink_details) {
      return sum + getDrinkLineTotal(item.drink_details);
    }
    const qty = Number(item?.qty || item?.quantity || 0);
    const price = Number(item?.price || 0);
    return sum + qty * price;
  }, 0);
};

const BillPanelNoContext = ({
  table,
  bills = [],
  initialBillId,
  onClose,

  menuItems = [],
  categories = [],

  onAddBill,
  onDeleteBill,
  onMergeBills,
  onSplitBill,
  onUpdateBillItems,
  onUpdateBillMeta,
  onCloseBill,

  getBillTotal,
  refreshBillsForTable,

  canCreateBill = false,
  canUpdateBill = false,
  canDeleteBill = false,
  generalSettings = {}, //  ADD THIS
  hideCapacity = false,
}) => {
  const [activeKey, setActiveKey] = useState(() =>
    initialBillId
      ? String(initialBillId)
      : bills[0]?.id
        ? String(bills[0].id)
        : null,
  );

  const [splitState, setSplitState] = useState({ billId: null, items: [] });
  const [mergeBillsOpen, setMergeBillsOpen] = useState(false);
  const [addingBill, setAddingBill] = useState(false);

  useEffect(() => {
    if (bills.length === 0) {
      setActiveKey(null);
      return;
    }

    const exists = bills.find((b) => String(b.id) === String(activeKey));
    if (!exists) {
      setActiveKey(bills[0]?.id ? String(bills[0].id) : null);
    }
  }, [bills, activeKey]);

  useEffect(() => {
    if (
      initialBillId &&
      bills.find((b) => String(b.id) === String(initialBillId))
    ) {
      setActiveKey(String(initialBillId));
    }
  }, [initialBillId, bills]);

  useEffect(() => {
    if (
      splitState.billId &&
      !bills.find((b) => String(b.id) === String(splitState.billId))
    ) {
      setSplitState({ billId: null, items: [] });
    }
  }, [bills, splitState.billId]);

  const handleAddBill = async () => {
    if (!canCreateBill || typeof onAddBill !== "function") return;

    setAddingBill(true);
    try {
      const newBill = await onAddBill(table.id);

      let updatedBills = [];
      if (typeof refreshBillsForTable === "function") {
        updatedBills = await refreshBillsForTable(table.id);
      }

      if (newBill?.id) {
        setActiveKey(String(newBill.id));
      } else if (updatedBills?.length) {
        const lastBill = updatedBills[updatedBills.length - 1];
        setActiveKey(String(lastBill.id));
      }
    } catch (err) {
      console.error("Add bill failed:", err);
    } finally {
      setAddingBill(false);
    }
  };

  const handleDelete = async (billIdKey) => {
    if (!canDeleteBill || typeof onDeleteBill !== "function") return;

    const billId = parseInt(billIdKey, 10) || billIdKey;
    await onDeleteBill(table.id, billId);
  };

  const activeBill = bills.find((b) => String(b.id) === String(activeKey));

  const splitTargetBill = splitState.billId
    ? bills.find((b) => String(b.id) === String(splitState.billId))
    : null;

  const zoneColorMap = {
    Outdoor: { bg: "#f6ffed", border: "#b7eb8f", text: "#52c41a" },
    Bar: { bg: "#f9f0ff", border: "#d3adf7", text: "#722ed1" },
    Private: { bg: "#fff7e6", border: "#ffd591", text: "#fa8c16" },
    Indoor: { bg: "#e6f7ff", border: "#91d5ff", text: "#1890ff" },
  };

  const zoneStyle = zoneColorMap[table?.zone] || {
    bg: "#f5f5f5",
    border: "#d9d9d9",
    text: "#8c8c8c",
  };

  const totalBills = bills.length;
  const totalItems = bills.reduce(
    (sum, bill) => sum + (bill.items?.length || 0),
    0,
  );

  const getBillStatus = (bill) => {
    const itemCount = bill.items?.length || 0;

    if (itemCount === 0) {
      return {
        label: "Empty",
        icon: <ClockCircleOutlined />,
        color: "#8c8c8c",
      };
    }

    if (bill.paid) {
      return {
        label: "Paid",
        icon: <CheckCircleOutlined />,
        color: "#52c41a",
      };
    }

    return {
      label: "Active",
      icon: <CoffeeOutlined />,
      color: "#1890ff",
    };
  };

  const actionMenu = (
    <Menu>
      {canUpdateBill && bills.length >= 2 && (
        <Menu.Item
          key="merge"
          icon={<MergeOutlined />}
          onClick={() => setMergeBillsOpen(true)}
        >
          Merge Bills
        </Menu.Item>
      )}

      {canCreateBill && (
        <Menu.Item key="add" icon={<PlusOutlined />} onClick={handleAddBill}>
          Add New Bill
        </Menu.Item>
      )}
    </Menu>
  );

  return (
    <Drawer
      className="bill-panel-drawer"
      placement="right"
      width={1120}
      open={true}
      onClose={onClose}
      closable={true}
      closeIcon={<span className="close-icon">×</span>}
      title={null}
    >
      <div className="bill-panel-container">
        <div className="bill-panel-header">
          <div className="bill-panel-header-main">
            <div className="table-info-card">
              <div
                className="table-icon"
                style={{
                  background: zoneStyle.bg,
                  borderColor: zoneStyle.border,
                }}
              >
                <ShopOutlined style={{ color: zoneStyle.text }} />
              </div>

              <div className="table-info">
                <div className="table-name-row">
                  <h2 className="table-name">{table?.name}</h2>
                  <Tag
                    className="zone-tag"
                    style={{
                      background: zoneStyle.bg,
                      color: zoneStyle.text,
                      borderColor: zoneStyle.border,
                    }}
                  >
                    {table?.zone || "Indoor"}
                  </Tag>
                </div>

                <div className="table-stats">
                  {!hideCapacity && (
                    <>
                      <div className="stat-item">
                        <TeamOutlined className="stat-icon" />
                        <span className="stat-value">
                          Capacity {table?.capacity}
                        </span>
                      </div>

                      <div className="stat-divider" />
                    </>
                  )}

                  <div className="stat-item">
                    <AppstoreOutlined className="stat-icon" />
                    <span className="stat-value">
                      {totalBills} {totalBills === 1 ? "bill" : "bills"}
                    </span>
                  </div>

                  <div className="stat-divider" />

                  <div className="stat-item">
                    <CoffeeOutlined className="stat-icon" />
                    <span className="stat-value">
                      {totalItems} {totalItems === 1 ? "item" : "items"}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="header-actions">
              {(canCreateBill || (canUpdateBill && bills.length >= 2)) && (
                <Dropdown
                  overlay={actionMenu}
                  trigger={["click"]}
                  placement="bottomRight"
                >
                  <Button
                    className="action-btn-mobile"
                    icon={<MoreOutlined />}
                  />
                </Dropdown>
              )}

              <div className="action-buttons">
                {canUpdateBill && bills.length >= 2 && (
                  <Button
                    icon={<MergeOutlined />}
                    onClick={() => setMergeBillsOpen(true)}
                    className="action-btn secondary"
                  >
                    Merge
                  </Button>
                )}

                {canCreateBill && (
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={handleAddBill}
                    loading={addingBill}
                    className="action-btn primary"
                  >
                    New Bill
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="bill-panel-body">
          {bills.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">📋</div>
              <Empty
                description={
                  <div className="empty-description">
                    <div className="empty-title">No active bills</div>
                    <div className="empty-subtitle">
                      Start a new bill for this table to begin ordering
                    </div>
                  </div>
                }
              >
                {canCreateBill && (
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={handleAddBill}
                    size="large"
                    className="create-bill-btn"
                  >
                    Create First Bill
                  </Button>
                )}
              </Empty>
            </div>
          ) : (
            <div className="bills-container">
              <div className="custom-tabs">
                <div className="tabs-topbar">
                  <div className="tabs-topbar-left">
                    <h3 className="tabs-title">Bills</h3>
                    <Text type="secondary" className="tabs-subtitle">
                      Switch bills, split current bill or delete it
                    </Text>
                  </div>

                  {activeKey && activeBill && (
                    <div className="bill-actions">
                      {canUpdateBill && (
                        <Button
                          icon={<ScissorOutlined />}
                          onClick={() =>
                            setSplitState({
                              billId: activeBill.id,
                              items: activeBill.items || [],
                            })
                          }
                          className="action-icon-btn"
                        >
                          Split
                        </Button>
                      )}

                      {canDeleteBill && (
                        <Popconfirm
                          title="Delete this bill?"
                          description="This action cannot be undone."
                          onConfirm={() => handleDelete(activeKey)}
                          okText="Delete"
                          cancelText="Cancel"
                          okButtonProps={{ danger: true }}
                        >
                          <Button
                            danger
                            icon={<DeleteOutlined />}
                            className="action-icon-btn"
                          >
                            Delete
                          </Button>
                        </Popconfirm>
                      )}
                    </div>
                  )}
                </div>

                <div className="tabs-header">
                  {bills.map((bill, idx) => {
                    const isEmptyBill =
                      !Array.isArray(bill?.items) || bill.items.length === 0;
                    const total = isEmptyBill ? 0 : getLiveBillTotal(bill);
                    const itemCount = bill.items?.length || 0;
                    const status = getBillStatus(bill);
                    const isActive = String(bill.id) === activeKey;

                    return (
                      <button
                        key={bill.id}
                        className={`tab-button ${isActive ? "active" : ""}`}
                        onClick={() => setActiveKey(String(bill.id))}
                        type="button"
                      >
                        <div className="tab-content">
                          <div className="tab-header">
                            <span className="tab-name">
                              {bill.mergedFrom
                                ? `Merged (${bill.mergedFrom})`
                                : `Bill ${idx + 1}`}
                            </span>

                            <div
                              className="tab-status"
                              style={{ color: status.color }}
                            >
                              {status.icon}
                              <span className="tab-status-text">
                                {status.label}
                              </span>
                            </div>
                          </div>

                          <div className="tab-footer">
                            <span className="tab-items">
                              {itemCount} {itemCount === 1 ? "item" : "items"}
                            </span>
                            <span className="tab-total">
                              ₹{total.toFixed(0)}
                            </span>
                          </div>
                        </div>
                      </button>
                    );
                  })}
                </div>

                <div className="tabs-content">
                  {activeBill && (
                    <BillEditorNoContext
                      key={activeBill.id}
                      bill={activeBill}
                      tableId={table.id}
                      table={table}
                      onSplit={
                        canUpdateBill
                          ? () =>
                              setSplitState({
                                billId: activeBill.id,
                                items: activeBill.items || [],
                              })
                          : undefined
                      }
                      updateBillItems={
                        canUpdateBill ? onUpdateBillItems : undefined
                      }
                      updateBillMeta={
                        canUpdateBill ? onUpdateBillMeta : undefined
                      }
                      closeBill={canUpdateBill ? onCloseBill : undefined}
                      getBillTotal={getBillTotal}
                      menuItems={menuItems}
                      categories={categories} 
                      generalSettings={generalSettings}
                    />
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {splitTargetBill && canUpdateBill && (
        <SplitBillModalNoContext
          bill={{
            ...splitTargetBill,
            items:
              splitState.items?.length > 0
                ? splitState.items
                : splitTargetBill.items || [],
          }}
          tableId={table.id}
          onClose={() => setSplitState({ billId: null, items: [] })}
          onSplitBill={async ({ item_ids }) => {
            let result = null;

            if (typeof onSplitBill === "function") {
              result = await onSplitBill(
                table.id,
                splitTargetBill.id,
                item_ids,
              );
            }

            let refreshedBills = [];
            if (typeof refreshBillsForTable === "function") {
              refreshedBills = await refreshBillsForTable(table.id);
            }

            const newBillId = result?.split?.id;

            if (newBillId) {
              setActiveKey(String(newBillId));
            } else if (
              Array.isArray(refreshedBills) &&
              refreshedBills.length > bills.length
            ) {
              const latestBill = refreshedBills[refreshedBills.length - 1];
              if (latestBill?.id) {
                setActiveKey(String(latestBill.id));
              }
            }

            setSplitState({ billId: null, items: [] });
          }}
        />
      )}

      {mergeBillsOpen && canUpdateBill && (
        <MergeBillsModalNoContext
          tableId={table.id}
          bills={bills}
          activeKey={activeKey}
          onClose={() => setMergeBillsOpen(false)}
          onMergeBills={async (sourceBillId, targetBillId) => {
            if (typeof onMergeBills === "function") {
              await onMergeBills(table.id, sourceBillId, targetBillId);
            }

            if (typeof refreshBillsForTable === "function") {
              await refreshBillsForTable(table.id);
            }

            setActiveKey(String(targetBillId));
            setMergeBillsOpen(false);
          }}
        />
      )}
    </Drawer>
  );
};

export default BillPanelNoContext;
